/* unplugin-vue-components disabled */import { render } from "./reset-modal.vue?vue&type=template&id=33742d61&scoped=true"
import script from "./reset-modal.vue?vue&type=script&lang=js"
export * from "./reset-modal.vue?vue&type=script&lang=js"

import "./reset-modal.vue?vue&type=style&index=0&id=33742d61&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33742d61"],['__file',"src/pages/settings/profile/reset-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33742d61"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33742d61', __exports__)) {
    api.reload('33742d61', __exports__)
  }
  
  module.hot.accept("./reset-modal.vue?vue&type=template&id=33742d61&scoped=true", () => {
    api.rerender('33742d61', render)
  })

}


export default __exports__